import React from "react";
import {
  GOVGR_ERROR_SUMMARY,
  GOVGR_HEADING_S,
  GOVGR_LINK,
} from "../../conf/styles/GovGrErrorSummary";
import { scrollToElementIdSmooth } from "../../utils/scrollToElementIdSmooth";

const GovGrErrorSummary = ({
  errorheading = "Υπήρξε κάποιο πρόβλημα",
  errorsummary = [
    { error: "Πρέπει να συμπληρώσετε το έτος", linkToErrorName: "error" },
  ],
}) => {
  return (
    <>
      {errorsummary.length !== 0 ? (
        <div className={`${GOVGR_ERROR_SUMMARY}`}>
          <h3 className={`${GOVGR_HEADING_S}`}>{errorheading}</h3>
          <div className="flex flex-col space-y-2">
            {errorsummary.map((item, index) =>
              item.linkToErrorName ? (
                <span
                  className={`${GOVGR_LINK}`}
                  key={index}
                  onClick={() => {
                    if (item !== null && item.linkToErrorName !== null && scrollToElementIdSmooth !== null) {
                      // console.log(item);
                      scrollToElementIdSmooth(item.linkToErrorName);
                    }
                  }
                  }
                >
                  {item.error}
                </span>
              ) : (
                <span key={index}>{item.error}</span>
              )
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default GovGrErrorSummary;
